import _ from 'es-toolkit/compat';
import { FULL_STATES, SHORT_STATES } from '@clearverify/constants';
export var StateType;
(function (StateType) {
    StateType["Full"] = "full";
    StateType["Abbreviation"] = "abbreviation";
})(StateType || (StateType = {}));
export const getFullState = (rawState) => {
    if (!rawState) {
        return null;
    }
    const stateType = getStateType(rawState);
    const state = stateType === StateType.Abbreviation ? rawState.toUpperCase() : _.startCase(rawState);
    if (!stateType || !isStateExists(state, stateType)) {
        return null;
    }
    if (stateType === StateType.Full) {
        return state;
    }
    return FULL_STATES[state] || null;
};
export const getStateType = (state) => {
    const SHORT_STATE_LENGTH = 2;
    if (state.length < SHORT_STATE_LENGTH) {
        return null;
    }
    return state.length === SHORT_STATE_LENGTH ? StateType.Abbreviation : StateType.Full;
};
export const isStateNameExists = (stateName) => Object.hasOwn(SHORT_STATES, stateName);
export const isStateAbbreviationExists = (abbreviation) => Object.values(SHORT_STATES).includes(abbreviation);
export const isStateExists = (state, stateType) => {
    return stateType === StateType.Abbreviation
        ? isStateAbbreviationExists(state)
        : isStateNameExists(state);
};
export const getShortState = (rawState) => {
    if (!rawState) {
        return null;
    }
    const stateType = getStateType(rawState);
    const state = stateType === StateType.Abbreviation ? rawState.toUpperCase() : _.startCase(rawState);
    if (!stateType || !isStateExists(state, stateType)) {
        return null;
    }
    if (stateType === StateType.Abbreviation) {
        return state;
    }
    return SHORT_STATES[state];
};
//# sourceMappingURL=state.js.map